import { useMessageInputContext } from 'stream-chat-react'
import { MessageInput, StyledButton } from './styles'
import SendRoundedIcon from '@mui/icons-material/SendRounded'
import { useChatSuport } from '@contexts/ChatSuport'
import { postChatMessageAPI } from '@services/nomos_api/resources/chat_event/postMessage'
import { StyledTextarea } from './muiStyles'
import { theme } from '@theme/index'

export function CustomMessageInput() {
  const { text, handleChange, handleSubmit } = useMessageInputContext()
  const { pending, getHistory, channel, setHistory, setPending } =
    useChatSuport()
  return (
    <MessageInput
      onKeyUp={(e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
          const messageHistory = getHistory()
          const localHistory = [
            ...messageHistory,
            {
              role: 'user',
              content: [
                {
                  type: 'text',
                  text,
                },
              ],
            },
          ]
          setHistory(localHistory)
          setPending(true)
          postChatMessageAPI({
            gptMessages: localHistory as never[],
            channel: {
              id: channel!.id!,
              type: 'messaging',
            },
          })
            .then((responses) => {
              const messageHistory = getHistory()

              const localHistory = [...messageHistory]
              // eslint-disable-next-line no-restricted-syntax
              for (const m of responses) {
                localHistory.push({
                  role: 'assistant',
                  id: m.id,
                  createdAt: m.created_at,
                  firstOfGroup: m.firstOfGroup,
                  total: m.total,
                  url: m.url,
                  filters: m.filters,
                  content: [
                    {
                      type: 'text',
                      text: m.gptMessage.content,
                    },
                  ],
                })
              }
              setHistory(localHistory)
            })
            .finally(() => {
              setPending(false)
            })
          handleSubmit()
        }
      }}
    >
      <StyledTextarea
        disabled={pending}
        value={text}
        onChange={handleChange}
        placeholder="Como posso te ajudar?"
        minRows={2}
        maxRows={15}
      />
      <StyledButton disabled={pending} onClick={handleSubmit} type="button">
        <SendRoundedIcon
          sx={{
            color: text.length > 0 ? theme.palette.brand.blue : '#8E8EA0',
          }}
        />
      </StyledButton>
    </MessageInput>
  )
}
